// extracted by mini-css-extract-plugin
module.exports = {"delete":"BranchItemSection__delete--1vGlu","nodelete":"BranchItemSection__nodelete--1vcrh","nodeleteText":"BranchItemSection__nodeleteText--27zBp"};